function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  y2: 0,
  x2: 0,
  y1: 0,
  x1: 1,
  id: "svg_34"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2b2b2b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d4d4d4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  y2: 0,
  x2: 0,
  y1: 1,
  x1: 0,
  id: "svg_36"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2b2b2b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d4d4d4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  y2: 1,
  x2: 1,
  y1: 0.5,
  x1: 0.5,
  id: "svg_163"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c9c9c9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#363636"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "#c9c9c9",
  id: "canvas_background",
  height: 602,
  width: 602,
  y: -1,
  x: -1
}), /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  display: "none",
  id: "canvasGrid"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#gridpattern)",
  strokeWidth: 0,
  height: 1200,
  width: 1600,
  id: "svg_1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("g", {
  id: "svg_3"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_7",
  height: 138.76986,
  width: 142.99835,
  y: 461.18075,
  x: 457.42222,
  strokeWidth: 1.5,
  fill: "#9db5b5",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_33",
  height: 139.94542,
  width: 31.70198,
  y: 460.8151,
  x: 430.12658,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "url(#svg_34)",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_35",
  height: 30.43518,
  width: 139.27036,
  y: 431.18171,
  x: 461.30659,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "url(#svg_36)",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  id: "svg_37",
  height: 30.19364,
  width: 31.86972,
  y: 431.06112,
  x: 429.70945,
  strokeWidth: 1.5,
  fill: "url(#svg_163)"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  rx: 8,
  id: "svg_58",
  height: 17.27386,
  width: 31.70198,
  y: 454.26026,
  x: 513.90757,
  strokeWidth: 1.5,
  fill: "#9db5b5"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  rx: 100,
  id: "svg_130",
  height: 4.99472,
  width: 20.86029,
  y: 457.70857,
  x: 519.28822,
  strokeWidth: 0.5,
  fill: "#e00000"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  rx: 8,
  id: "svg_59",
  height: 30.43518,
  width: 10.30314,
  y: 528.16552,
  x: 456.26306,
  strokeWidth: 1.5,
  fill: "#9db5b5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#d36200",
  id: "svg_157",
  d: "m516.71245,531.44211l-0.0193,41.40531l-12.22437,-13.62725l0.0193,-41.40531l37.14276,-0.0215l12.22437,13.62725l-37.14276,0.0215z",
  strokeWidth: 1.5,
  fill: "#009e9e"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  rx: 100,
  id: "svg_2",
  height: 4.99472,
  width: 20.86029,
  y: 541.20857,
  x: 451.28822,
  strokeWidth: 0.5,
  fill: "#e00000",
  transform: "rotate(90 461.7183532714843,543.7059326171876) "
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 84.54319763183594,84.51081848144531) ",
  id: "svg_15"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_4",
  height: 138.76986,
  width: 142.99835,
  y: 29.78075,
  x: 26.82222,
  strokeWidth: 1.5,
  fill: "#9db5b5",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_5",
  height: 139.94542,
  width: 31.70198,
  y: 29.4151,
  x: -0.47342,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "url(#svg_34)",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_6",
  height: 30.43518,
  width: 139.27036,
  y: -0.21829,
  x: 30.70659,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "url(#svg_36)",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  id: "svg_8",
  height: 30.19364,
  width: 31.86972,
  y: -0.33888,
  x: -0.89055,
  strokeWidth: 1.5,
  fill: "url(#svg_163)"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  rx: 8,
  id: "svg_9",
  height: 17.27386,
  width: 31.70198,
  y: 22.86026,
  x: 83.30757,
  strokeWidth: 1.5,
  fill: "#9db5b5"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  rx: 100,
  id: "svg_10",
  height: 4.99472,
  width: 20.86029,
  y: 26.30857,
  x: 88.68822,
  strokeWidth: 0.5,
  fill: "#e00000"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  rx: 8,
  id: "svg_11",
  height: 30.43518,
  width: 10.30314,
  y: 96.76552,
  x: 25.66306,
  strokeWidth: 1.5,
  fill: "#9db5b5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#d36200",
  id: "svg_13",
  d: "m86.11245,100.04211l-0.0193,41.40531l-12.22437,-13.62725l0.0193,-41.40531l37.14276,-0.0215l12.22437,13.62725l-37.14276,0.0215z",
  strokeWidth: 1.5,
  fill: "#009e9e"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  rx: 100,
  id: "svg_14",
  height: 4.99472,
  width: 20.86029,
  y: 109.80857,
  x: 20.68822,
  strokeWidth: 0.5,
  fill: "#e00000",
  transform: "rotate(90 31.118370056152333,112.3059539794922) "
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 84.5432128906249,514.9111938476564) ",
  id: "svg_26"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_17",
  height: 138.76986,
  width: 142.99835,
  y: 460.18119,
  x: 26.82222,
  strokeWidth: 1.5,
  fill: "#9db5b5",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_18",
  height: 139.94542,
  width: 31.70198,
  y: 459.81554,
  x: -0.47342,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "url(#svg_34)",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_19",
  height: 30.43518,
  width: 139.27036,
  y: 430.18215,
  x: 30.70659,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "url(#svg_36)",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  id: "svg_20",
  height: 30.19364,
  width: 31.86972,
  y: 430.06156,
  x: -0.89055,
  strokeWidth: 1.5,
  fill: "url(#svg_163)"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  rx: 8,
  id: "svg_21",
  height: 17.27386,
  width: 31.70198,
  y: 453.2607,
  x: 83.30757,
  strokeWidth: 1.5,
  fill: "#9db5b5"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  rx: 100,
  id: "svg_22",
  height: 4.99472,
  width: 20.86029,
  y: 456.70901,
  x: 88.68822,
  strokeWidth: 0.5,
  fill: "#e00000"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  rx: 8,
  id: "svg_23",
  height: 30.43518,
  width: 10.30314,
  y: 527.16596,
  x: 25.66306,
  strokeWidth: 1.5,
  fill: "#9db5b5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#d36200",
  id: "svg_24",
  d: "m86.11245,530.44255l-0.0193,41.40531l-12.22437,-13.62725l0.0193,-41.40531l37.14276,-0.0215l12.22437,13.62725l-37.14276,0.0215z",
  strokeWidth: 1.5,
  fill: "#009e9e"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  rx: 100,
  id: "svg_25",
  height: 4.99472,
  width: 20.86029,
  y: 540.20901,
  x: 20.68822,
  strokeWidth: 0.5,
  fill: "#e00000",
  transform: "rotate(90 31.118366241454968,542.7062988281251) "
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 515.7435913085939,85.31079101562496) ",
  id: "svg_42"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_28",
  height: 138.76986,
  width: 142.99835,
  y: 30.58073,
  x: 458.02268,
  strokeWidth: 1.5,
  fill: "#9db5b5",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_29",
  height: 139.94542,
  width: 31.70198,
  y: 30.21508,
  x: 430.72704,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "url(#svg_34)",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_30",
  height: 30.43518,
  width: 139.27036,
  y: 0.58169,
  x: 461.90705,
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "url(#svg_36)",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  id: "svg_31",
  height: 30.19364,
  width: 31.86972,
  y: 0.4611,
  x: 430.30991,
  strokeWidth: 1.5,
  fill: "url(#svg_163)"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  rx: 8,
  id: "svg_32",
  height: 17.27386,
  width: 31.70198,
  y: 23.66024,
  x: 514.50803,
  strokeWidth: 1.5,
  fill: "#9db5b5"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  rx: 100,
  id: "svg_38",
  height: 4.99472,
  width: 20.86029,
  y: 27.10855,
  x: 519.88868,
  strokeWidth: 0.5,
  fill: "#e00000"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  rx: 8,
  id: "svg_39",
  height: 30.43518,
  width: 10.30314,
  y: 97.5655,
  x: 456.86352,
  strokeWidth: 1.5,
  fill: "#9db5b5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#d36200",
  id: "svg_40",
  d: "m517.3129,100.84209l-0.0193,41.40531l-12.22437,-13.62725l0.0193,-41.40531l37.14276,-0.0215l12.22437,13.62725l-37.14276,0.0215z",
  strokeWidth: 1.5,
  fill: "#009e9e"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  rx: 100,
  id: "svg_41",
  height: 4.99472,
  width: 20.86029,
  y: 110.60855,
  x: 451.88868,
  strokeWidth: 0.5,
  fill: "#e00000",
  transform: "rotate(90 462.3187255859375,113.10583496093754) "
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 600 600"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/NESW.7b05dca3.svg";
export { SvgComponent as ReactComponent };